__turbopack_context__.v({
  "container": "ProgramCurriculumLp-module-scss-module__HxUCnq__container",
  "containerInner": "ProgramCurriculumLp-module-scss-module__HxUCnq__containerInner",
  "downloadBrochure": "ProgramCurriculumLp-module-scss-module__HxUCnq__downloadBrochure",
  "heading": "ProgramCurriculumLp-module-scss-module__HxUCnq__heading",
  "lhs": "ProgramCurriculumLp-module-scss-module__HxUCnq__lhs",
  "perOuterSemester": "ProgramCurriculumLp-module-scss-module__HxUCnq__perOuterSemester",
  "perSemBtn": "ProgramCurriculumLp-module-scss-module__HxUCnq__perSemBtn",
  "perSemBtnSelected": "ProgramCurriculumLp-module-scss-module__HxUCnq__perSemBtnSelected",
  "perSemester": "ProgramCurriculumLp-module-scss-module__HxUCnq__perSemester",
  "rhs": "ProgramCurriculumLp-module-scss-module__HxUCnq__rhs",
  "rotate0": "ProgramCurriculumLp-module-scss-module__HxUCnq__rotate0",
  "rotate180": "ProgramCurriculumLp-module-scss-module__HxUCnq__rotate180",
  "semBtnWrapper": "ProgramCurriculumLp-module-scss-module__HxUCnq__semBtnWrapper",
  "semBtnWrapperInner": "ProgramCurriculumLp-module-scss-module__HxUCnq__semBtnWrapperInner",
  "semesterContent": "ProgramCurriculumLp-module-scss-module__HxUCnq__semesterContent",
  "semesterContentInner": "ProgramCurriculumLp-module-scss-module__HxUCnq__semesterContentInner",
  "semesterContentOpen": "ProgramCurriculumLp-module-scss-module__HxUCnq__semesterContentOpen",
  "semesterWrapper": "ProgramCurriculumLp-module-scss-module__HxUCnq__semesterWrapper",
  "tickIcon": "ProgramCurriculumLp-module-scss-module__HxUCnq__tickIcon",
  "tickIconMweb": "ProgramCurriculumLp-module-scss-module__HxUCnq__tickIconMweb",
  "ugcDegree": "ProgramCurriculumLp-module-scss-module__HxUCnq__ugcDegree",
  "ugcDegreeBigImg": "ProgramCurriculumLp-module-scss-module__HxUCnq__ugcDegreeBigImg",
  "ugcDegreeImg": "ProgramCurriculumLp-module-scss-module__HxUCnq__ugcDegreeImg",
  "ugcWrapper": "ProgramCurriculumLp-module-scss-module__HxUCnq__ugcWrapper",
});
